import { NgIf, NgStyle } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'formly-wrapper-panel',
  template: `
  <div class="flex flex-col border border-t-4 border-t-primary shadow-sm rounded-xl mb-6 w-full">
  <div class="p-4 md:p-5">
    <h3 class=" font-semibold text-white dark:text-white rounded bg-primary py-1 px-2 max-w-max"> {{props?.label}}</h3>
    <div class="mt-7 grid grid-flow-col auto-cols-fit auto-rows-fit">
    <ng-container #fieldComponent></ng-container>
    </div>
  </div>
</div>
  `,
  standalone: true,
  imports: [FormlyModule]
})
export class TopBorderPanel extends FieldWrapper {


}
